import { Flex, Image, Text, useColorModeValue } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebase-config";
import Spinner from './Spinner'
import { useParams } from 'react-router-dom';
import { getUserInfo, userUploadedVideos } from '../utils/fetchData';
import RecommendedVideos from './RecommendedVideos';

import {
  FcApproval
} from 'react-icons/fc'

const randomImage = "https://source.unsplash.com/1600x900/?nature,photography,technology";

const UserProfile = () => {
  const { userId } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [userInfo, setUserInfo] = useState(null)
  const [feeds, setFeeds] = useState(null)

  const textcolor = useColorModeValue('gray.500', 'gray.100');


  const fireStoreDb = getFirestore(firebaseApp);


  useEffect(() => {
    setIsLoading(true);
    if (userId) {
      getUserInfo(fireStoreDb, userId).then(user => {
        setUserInfo(user);
      })
      userUploadedVideos(fireStoreDb, userId).then((feed) => {
        setFeeds(feed)
      })
      setIsLoading(false);
    }
  }, [userId])

  if (isLoading) return <Spinner />

  return <Flex
    alignItems={'center'}
    justifyContent='center'
    width={'full'}
    height='auto'
    p={2}
    direction='column'
  >
    <Flex
      alignItems={'center'}
      justifyContent='center'
      width={'full'}
      height='auto'
      p={2}
      direction='column'
    >
      <Image
        src={randomImage}
        height={{base: '200px', md: '300px', lg: '320px'}}
        width='full'
        objetFit={'cover'}
        borderRadius={'md'}
      />
      <Image
        src={userInfo?.photoURL}
        width='120px'
        objectFit={'cover'}
        border='2px'
        borderColor={'gray.100'}
        rounded='full'
        shadow={'lg'}
        mt='-16'
      />
    </Flex>
    <Text
            fontSize={{ base: '12px', md: '12px', lg: '12px' }}
            isTruncated
            color={textcolor}
            fontWeight='semibold'
          >
            <Flex>{userInfo?.displayName} <FcApproval /> </Flex>                                           
    </Text>
    {
      feeds && (
        <Flex
          direction={'column'}
          width='full'
          my={16}
        >
          <RecommendedVideos feeds={feeds} />
        </Flex>
      )
    }
  </Flex>
}

export default UserProfile